module.exports = __webpack_public_path__ + "img/logo-openagent-green-grey.aefe06d9.svg";